<template>
  <div class="physio-warp" v-loading.fullscreen.lock="loading">
    <div class="physio-left">
      <div class="physio-left-top">
        <custom-input class="search-input" clearable v-model.trim="searchFrom.searchValue" prefix-icon="el-icon-search"
          placeholder="搜索姓名/手机号" @input="handleSearch"></custom-input>
      </div>
      <div class="physio-left-middle">
        <div v-if="userType === '1'" class="left_helper">
          <el-select class="left_helper_select" v-model="searchFrom.doctorId" placeholder="助理的医生" :popper-append-to-body="false" @change="changeListDoctor">
            <div class="left_helper_select_label">助理的医生</div>
            <el-option v-for="doctor in helperDoctorList" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
          </el-select>
        </div>
        <div class="left-middle-tab">
          <div class="display-f">
            <div v-if="!['0', '1'].includes(userType)" :class="{ 'tab-item': true, 'active': searchFrom.searchType == '0' }" @click="changeTab('0')">本馆开单</div>
            <div :class="{ 'tab-item': true, 'active': searchFrom.searchType == '1' }" @click="changeTab('1')">我可执行</div>
            <div :class="{ 'tab-item': true, 'active': searchFrom.searchType == '2' }" @click="changeTab('2')">今日预约</div>
            <div v-if="['0', '1'].includes(userType)"  :class="{ 'tab-item': true, 'active': searchFrom.searchType == '3' }" @click="changeTab('3')">我的开单</div>
          </div>
        </div>
        <div v-if="searchFrom.searchType !== '2'" class="left_filter">
          <template>
            <div class="filter_row">
              <el-select v-if="['0', '1'].includes(userType)" class="filter_select" v-model="searchFrom.isCurrentDept" clearable placeholder="全部开单医馆" @change="changeListDept">
                <el-option label="本馆开单" value="1"></el-option>
              </el-select>
              <el-select v-if="!['0', '1'].includes(userType)" class="filter_select" v-model="searchFrom.doctorId" filterable clearable placeholder="全部开单医生" @change="changeListDoctor">
                <el-option v-for="doctor in deptDoctorList" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
              </el-select>
              <el-select class="filter_select" v-model="searchFrom.physioStatus" clearable placeholder="全部状态" @change="changeListStatus">
                <el-option label="待执行" value="1"></el-option>
                <el-option label="已结束" value="2"></el-option>
              </el-select>
            </div>
            <div class="filter_row">
              <el-date-picker
                class="filter_date_picker"
                v-model="searchFrom.dateRange"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="下次执行开始"
                end-placeholder="下次执行结束"
                @change="changeListDate">
              </el-date-picker>
            </div>
          </template>
        </div>
        <div v-if="searchFrom.searchType !== '2'" class="list_title">
          <div class="list_title_patient">患者</div>
          <div class="list_title_time">
            <el-tooltip class="item" effect="light" content="根据上次执行时间及执行频率计算出建议的下次执行日期" placement="top">
              <span class="el-icon-question list_title_time_icon"></span>
            </el-tooltip>
            <span class="list_title_time_text" @click="changeListTimeSort">下次执行</span>
            <div class="list_title_time_sort" @click="changeListTimeSort">
              <div :class="{ 'el-icon-caret-top': true, 'list_title_time_sort_top': true, 'active': searchFrom.excNextDaySort === 1 }"></div>
              <div :class="{ 'el-icon-caret-bottom': true, 'list_title_time_sort_bottom': true, 'active': searchFrom.excNextDaySort === 2 }"></div>
            </div>
          </div>
          <div class="list_title_status">状态</div>
        </div>
        <div class="middle-list" v-loadMore="getMoreList">
          <template v-if="searchFrom.searchType !== '2'">
            <div
              v-for="item in physioList"
              :key="item.accountId"
              :class="activeId == item.accountId ? 'list-item active' : 'list-item'"
              @click="choosePatient(item.patientId, item.accountId, item.patient)">
              <div class="item-left">
                <img v-if="item.patient.sex == '1'" :src="imgArr.girlIcon" class="mr6 sex-icon" />
                <img v-else :src="imgArr.manIcon" class="mr6 sex-icon" />
                <div>
                  {{ item.patientName ? item.patientName : '匿名患者' }}
                  <span class="color667 ml6 size12" :class="{ 'active': activeId == item.accountId }" v-if="item.patient && item.patient.phone">{{ item.patient.phone.slice(-4) }}</span>
                </div>
              </div>
              <div class="item-right">
                <div class="item-right-time" v-if="searchFrom.searchType !== '2'">{{ item.patient.excNextDay && new Date(item.patient.excNextDay).Format('yyyy-MM-dd') || '-' }}</div>
                <div v-for="obj in physioStatusList" :key="obj.value">
                  <div v-if="item.physioStatus == obj.value" class="item-status" :class="{ 'active': activeId == item.accountId }" :style="{ color: obj.fontColor, }">{{ item.physioStatus | filterStatus }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="searchFrom.searchType === '2'">
            <div
              v-for="item in physioList"
              :key="item.accountId"
              :class="activeId == item.accountId ? 'today_item today_active' : 'today_item'"
              @click="choosePatient(item.patientId, item.accountId, item.patient)">
              <div class="today_header">
                <div class="today_header_left">
                  <img class="today_header_sex" :src="item.patient.sex == '1' ? imgArr.girlIcon : imgArr.manIcon" />
                  <div class="today_header_name">{{ item.patientName ? item.patientName : '匿名患者' }}</div>
                  <div class="today_header_phone">{{ item.patient.phone ? item.patient.phone.slice(-4) : '-' }}</div>
                  <div class="today_tags">
                    <div v-if="['applet-quick', 'trilateral', 'weapp-doctor-quick'].includes(item.source)" class="today_tag_notPurchased">未购买</div>
                    <div v-if="item.source === 'platform-intermediary' && item.plat === 1" class="today_tag_meituan">美团</div>
                  </div>
                </div>
                <div class="today_header_right">
                  <div class="today_header_status" :style="{ color: reservationStatusMap[item.reservation] && reservationStatusMap[item.reservation].color }">{{ reservationStatusMap[item.reservation] && reservationStatusMap[item.reservation].text }}</div>
                </div>
              </div>
              <div class="today_description">
                <div v-if="item.reservationDetails && item.reservationDetails.length > 0" class="today_row">预约项目：{{ item.reservationDetails.map(v => v.physioName).join('、') }}</div>
                <div class="today_row">预约时间：{{ new Date(item.reservationStartTime).Format('hh:mm') }}-{{ new Date(item.reservationEndTime).Format('hh:mm') }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="physio-left-bottom">
        <div class="left-bottom-title">小工具</div>
        <el-popover v-if="['0', '1'].includes(userType)" ref="callNumPopover" placement="right-end" trigger="click" width="390" @show="openCallNum">
          <CallNumPanel ref="callNumPanel" @close="closeCallNum"></CallNumPanel>
          <div slot="reference" class="board">
            <div class="board-title">
              <img class="board-title-icon" :src="imgArr.callNum" />
              <span class="board-title-text">叫号</span>
            </div>
            <div class="collect">下一位<i class="el-icon-arrow-right"></i></div>
          </div>
        </el-popover>
        
        <div class="board" @click="openBoard">
          <div class="board-title">
            <img class="board-title-icon" :src="imgArr.dataBoardNew" />
            <span class="board-title-text">执行看板</span>
          </div>
          <div class="collect">我的工作汇总<i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="board" @click="openReservationBoard">
          <div class="board-title">
            <img class="board-title-icon" :src="imgArr.dataBoardNew" />
            <span class="board-title-text">预约看板</span>
          </div>
          <div class="collect">查看<i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="board" @click="openTrilateralReservation">
          <div class="board-title">
            <img class="board-title-icon" :src="imgArr.dataBoardNew" />
            <span class="board-title-text">三方客户预约</span>
          </div>
          <div class="collect">查看<i class="el-icon-arrow-right"></i></div>
        </div>
        <!-- 预约看板 -->
        <ReservationBoard ref="reservationBoard"></ReservationBoard>
        <TrilateralReservationDialog ref="trilateralReservationDialog"></TrilateralReservationDialog>
      </div>
    </div>
    <div class="physio-center" v-loading="centerLoading">
      <div class="center-top">
        <div class="top-title">理疗</div>
      </div>
      <div class="center-content">
        <div class="patient-warp">
          <span class="iconfont icon-nan" :class="patientInfo.sex == '1' ? 'colorF54A' : 'color1890'"></span>
          <div class="ml8">{{ patientInfo.patientName }}</div>
          <div class="ml30">{{ patientInfo.sex == '0' ? '男' : '女' }}</div>
          <div class="ml20">{{ patientInfo.age }}岁</div>
          <!-- <div class="ml10">{{patientInfo.}}月</div> -->
          <div class="ml10">{{ patientInfo.phone }}</div>
        </div>
        <div class="status-warp">
          <div class="status-warp-list">
            <div class="status-warp-list-item" :class="{ 'status-warp-list-item-active': status.value == activeStatus }"
              v-for="status in statusList" :key="status.value" @click="changeStatus(status.value)">{{ status.label }}
            </div>
          </div>
        </div>
        <div class="list-warp" v-if="tableData.length > 0">
          <div class="table-warp" v-for="item in tableData" :key="item.orderNumber">
            <div v-if="item.isTodayReservation" class="today_reservation">今日预约</div>
            <div class="table-title-warp">
              <div class="title-left">
                <img :src="imgArr.executeIcon" class="execute-icon" alt="">
                <div>医生：{{ item.doctorName }}</div>
                <div class="ml16">收费时间：{{ item.payTime }}</div>
                <div>（{{ item.deptName }}）</div>
              </div>
              <div class="title-right">
                <div>{{ item.orderNumber }}</div>
                <el-popover popper-class="physioExecute_advice_popover" placement="bottom" width="400" trigger="click">
                  <div class="physio_remark_content">
                    <div v-if="item.physioRemarkList.length > 0" class="order_remark">
                      <div class="order_remark_title">处方备注：</div>
                      <div class="order_remark_list">
                        <div v-for="remark in item.physioRemarkList" class="order_remark_item">
                          <div class="order_remark_item_label">{{ remark.label }}：</div>
                          <div class="order_remark_item_value">{{ remark.value }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="order_advice">
                      <div class="order_advice_title">医嘱事项：</div>
                      <div class="order_advice_info">{{ item.doctorAdvice || '暂无医嘱内容' }}</div>
                    </div>
                  </div>
                  <div slot="reference" class="title_right_btn_advice">
                    <span>查看医嘱</span>
                    <span v-if="item.physioRemarkList.length > 0" class="title_right_btn_point"></span>
                  </div>
                </el-popover>
                <div class="title_right_btn_quick" v-if="activeStatus == '0'" @click="quickReservation(item)">快捷预约</div>
                <div class="title-right-btn" v-if="activeStatus == '0'" @click="multipleExecute(item)">执行</div>
              </div>
            </div>
            <div class="bb-E0E">
              <div class="table-item">
                <div class="table-item-check" v-if="activeStatus == '0'">
                </div>
                <div class="table-item-name fwb pl12">项目名称</div>
                <div class="table-item-10 color949 pl12">执行频率</div>
                <div class="table-item-10 color949 pl12">开单次数</div>
                <div class="table-item-15 color949 pl12">退费次数</div>
                <div class="table-item-10 color949 textRight pr12">执行进度</div>
                <div class="table-item-action color949">操作</div>
              </div>
              <div v-for="(obj, objIndex) in item.orderCasePhysios" :key="objIndex" class="bt-E0E">
                <div class="table-item-title">
                  <div class="table-item-check" v-if="activeStatus == '0'">
                    <el-checkbox v-model="obj.checked" :disabled="obj.orderPhysioProperties.every(v=>{ return judgeIsExecute(v) })"
                      @change="allSelect(obj)"></el-checkbox>
                  </div>
                  <div class="pl12 color949 size12">理疗处方{{ objIndex + 1 }}</div>
                </div>
                <div class="table-item" v-for="(phy, phyIndex) in obj.orderPhysioProperties" :key="phyIndex">
                  <div class="table-item-check" v-if="activeStatus == '0'">
                    <el-checkbox :disabled="judgeIsExecute(phy)"
                      v-model="phy.checked" @change="judgeAllChecked"></el-checkbox>
                  </div>
                  <div class="table-item-name pl12">{{ phy.physioName }}</div>
                  <div class="table-item-10 pl12">{{ phy.executeDesc }}</div>
                  <div class="table-item-10 pl12">{{ computedDivision(phy.totalNum, phy.onlyNum) }}<span class="color949"
                      v-if="phy.onlyNum && phy.executionMode == 20">({{ phy.onlyNum }}组/次)</span></div>
                  <div class="table-item-15 pl12">{{ computedDivision(phy.refundNum, phy.onlyNum) }}</div>
                  <div class="table-item-10 textRight pr12">{{ phy.executionMode == 20 ?
                    computedDivision(phy.executeNum, phy.onlyNum) : phy.executeNum }}/{{ judgeTotalNum(phy) }}</div>
                  <div class="table-item-action color949">
                    <el-button type="text" @click="handleExecute(item, phy)" v-if="activeStatus == '0'"
                      :disabled="judgeIsExecute(phy)">执行</el-button>
                    <el-button type="text" @click="handleDetail(phy)">查看执行记录</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noData-warp" v-else>暂无数据</div>
        <div class="page-warp">
          <el-pagination layout="prev, pager, next" :current-page="pageIndex" :page-size="pageSize" :total="pageTotal" @current-change="currentPageFun">
          </el-pagination>
        </div>
      </div>
      <QuickReservationDialog ref="quickReservationDialog"></QuickReservationDialog>
    </div>

    <div class="physio-right">
      <div class="right-top">
        <div :class="{'right-top-title': true, 'active': activeRecordTab == 1}" @click="toggleRecordTab(1)">执行记录 <span v-if="recodeList.length > 0" class="size12 color6671">{{ recodeList.length }}</span></div>
        <div :class="{'right-top-title': true, 'active': activeRecordTab == 2}" @click="toggleRecordTab(2)">关怀记录 <span v-if="careRecordMap.total > 0" class="size12 color6671">{{ careRecordMap.total }}</span></div>
      </div>
      <!-- 执行记录 -->
      <div v-if="activeRecordTab == 1" class="right-content">
        <div class="right-content-search">
          <el-input
            placeholder="执行ID/项目名称"
            prefix-icon="el-icon-search"
            v-model="recodeSearch"
            clearable
            @input="recodeSearchInput">
          </el-input>
        </div>
        <el-collapse accordion v-model="activeName">
          <el-collapse-item
            v-for="item in recodeList"
            :key="item.accountPhysioExecuteRecordId"
            :name="item.accountPhysioExecuteRecordId">
            <template slot="title">
              <div class="right-title">
                <div class="display-f align-i-c">
                  <div class="w68 text-overflow">{{ item.userName }}</div>
                  <el-tooltip
                    effect="light"
                     v-if="item.isRevoke"
                    :disabled="!item.isRevoke"
                    :content="`撤销人：${item.revokeUserName}`"
                    placement="top">
                    <div class="revoke">已撤销</div>
                  </el-tooltip>
                </div>
                <div class="display-f align-i-c ml4">
                  <div class="w85 color6671 text-overflow textRight mr8">{{ item.diagnosis }}</div>
                  <div class="flex-sh">{{ item.executeStartTime | filterTime }}</div>
                </div>
              </div>
            </template>
            <div class="right-detail">
              <div class="right-detail-header" v-if="!item.isRevoke">
                <el-button @click="print(item)" size="medium" v-if="!item.isRevoke">打 印</el-button>
                <el-tooltip
                  class="item"
                  effect="light"
                  v-if="!item.isRevoke"
                  :disabled="item.canRevoke"
                  content="仅该记录的执行医生可撤销本月内记录"
                  placement="top-start">
                  <el-button
                    @click="revokeExecute(item)"
                    size="medium"
                    :disabled="(!item.canRevoke && ![81, 759].includes(user.userId))">
                    撤销执行
                    <i v-if="!item.canRevoke" class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </div>
              
              <!-- <el-button v-if="!item.isRevoke" @click="revokeExecute(item)" size="medium">撤销执行</el-button> -->
              <div class="physio-item" v-for="obj in item.items" :key="obj.physioId">
                <div class="right-detail-id">ID：{{ obj.accountPhysioExecuteRecordId }}</div>
                <div class="display-f just-b" v-if="item.isRevoke">
                  <div>撤销时间：</div>
                  <div>{{ item.revokeTime }}</div>
                </div>
                <div class="display-f just-b">
                  <div>{{ obj.physioName }}</div>
                  <div>执行次数：{{ obj.executeNum }}</div>
                </div>
                <div class="color6671 size13 display-f ">
                  <div class="flex-sh">诊断：</div>
                  <div>{{ obj.diagnosis }}</div>
                </div>
                <div class="color6671 size13 display-f">
                  <div class="flex-sh">治疗部位：</div>
                  <div>{{ obj.physioPosition }}</div>
                </div>
                <div class="color6671 size13 display-f">
                  <div class="flex-sh">治疗穴位：</div>
                  <div>
                    {{ obj.acupoint }}
                  </div>
                </div>
                <div class="color6671 size13 display-f">
                  <div class="flex-sh">治疗反应：</div>
                  <div>{{ obj.reaction }}</div>
                </div>
                <div class="color6671 size13 display-f">
                  <div class="flex-sh">治疗时长：</div>
                  <div>{{ obj.executeTimeLength }}</div>
                </div>
                <div class="color6671 size13 display-f">
                  <div class="flex-sh">注意事项：</div>
                  <div>{{ obj.note }}</div>
                </div>
                <div class="date-warp">
                  <div class="date-item">
                    <div class="date-item-time">收费：{{ obj.payTime }}</div>
                    <div class="date-item-user" :title="obj.doctorName">开方医生：{{ obj.doctorName }}</div>
                  </div>
                  <div class="date-item">
                    <div class="date-item-time">执行：{{ obj.executeStartTime }}</div>
                    <div class="date-item-user" :title="obj.userName">执行医生：{{ obj.userName }}</div>
                  </div>
                  <div class="date-item-total">合计：¥{{ obj.costMoney }}</div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 关怀记录 -->
      <div v-if="activeRecordTab == 2" class="right-content">
        <div class="care_header">
          <div class="care_header_left">共{{ careRecordMap.total }}条记录</div>
          <div class="care_header_right">
            <el-button class="care_header_right_btn" icon="el-icon-plus" @click="addCareRecord">添加记录</el-button>
          </div>
        </div>
        <div class="care_list" v-loadMore="getMoreCareRecordList">
          <div v-for="record in careRecordMap.list" :key="record.crId" class="care_list_item">
            <div class="care_item_axis">
              <div class="care_item_point"></div>
              <div class="care_item_line"></div>
            </div>
            <div class="care_item_card">
              <div class="care_card_header">
                <div class="care_card_header_left">
                  <div class="care_card_time">{{ new Date(record.assignCreateTime).Format('MM-dd') }}</div>
                  <div :class="{ 'care_card_tag': true, 'phone': record.contactWay === 1, 'wechat': record.contactWay === 2 }">
                    <span :class="{'el-icon-phone-outline': record.contactWay === 1, 'el-icon-chat-dot-round': record.contactWay === 2, 'care_card_tag_icon': true}"></span>
                    <span class="care_card_tag_text">{{ record.contactWay === 1 ? '电话' : '微信' }}</span>
                  </div>
                </div>
                <div class="care_card_header_right">{{ record.assignCreateByName }}</div>
              </div>
              <div class="card_card_content">
                <ExpandableText :text="record.content" :maxLines="4"></ExpandableText>
              </div>
              <div class="card_card_footer">
                <span class="el-icon-user card_card_footer_icon"></span>
                <span class="card_card_footer_text">{{ record.createByName }} {{ new Date(record.createTime).Format('yyyy-MM-dd hh:mm') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CareRecordEdit ref="careRecordEdit" @success="submitCareRecordSuccess"></CareRecordEdit>
      <!-- 弹框 -->
      <div>
        <div v-for="item in levelData" :key="item.name">
          <div v-if="visibleObj[item.name]">
            <component :is="item.dialog" v-if="visibleObj[item.name]" :ref="item.ref" :visibleObj="visibleObj"
              @close="dialogVisible" @updateData="confirmUpdateData" :dialogObj="dialogObj"
              @executeAndPrint="executeAndPrint" @cancelExecute="cancelExecute"></component>
          </div>
        </div>
      </div>
      <!-- 打印 -->
      <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
        @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
        @printSuccess="printSuccess" :id="printOrderId" :orderType="14" :printType="5">
      </printDialog>
    </div>
  </div>
</template>
<script>
import CustomInput from '@/components/CustomInput'
import { drugDTO, CommonDTO } from '@/DTO/index'
import { getTodayReservations, getReservationDetailByPatientId } from '@/api/physio.js'
import { physioStatusList, propertyStatusList } from '@/utils/const'
import { isNull, dictText, isEmptyArray, debounce, msgboxWarning } from '@/utils/validateBase'
import customTable from '@/components/customTable/customTable'
import { levelData, visibleObj } from '@/components/js/dialog'
import executeDialog from './components/executeDialog.vue'
import executePrintDialog from './components/executePrintDialog.vue'
import executeDetail from './components/executeDetail.vue'
import executeBoardDialog from './components/executeBoardDialog.vue'
import ReservationBoard from '@/components/physio/reservationBoard.vue'
import QuickReservationDialog from '@/components/physio/quickReservationDialog.vue'
import TrilateralReservationDialog from '@/components/physio/trilateralReservationDialog.vue'
import printDialog from '@/components/printDialog'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { imgArr } from '@/assets/images/img'
import { computed } from 'vue'
import CareRecordEdit from './components/CareRecordEdit.vue'
import ExpandableText from '@/components/ExpandableText.vue'
import CallNumPanel from './components/CallNumPanel.vue'
import req from '@/utils/request'

export default {
  // 定义引入的组件
  components: { printDialog, CustomInput, customTable, executeDialog, executePrintDialog, executeDetail, executeBoardDialog, ReservationBoard, QuickReservationDialog, TrilateralReservationDialog, CareRecordEdit, ExpandableText, CallNumPanel },
  props: {},
  data() {
    return {
      userType: '',
      imgArr: imgArr,
      activeRecordTab: 1,
      systemTime: '',//系统时间
      activeName: '',//
      loading: false,//加载动画
      deptDoctorList: [],
      helperDoctorList: [],
      searchFrom: {
        searchType: '1',
        searchValue: '',
        isCurrentDept: '',
        physioStatus: '',
        dateRange: [],
        doctorId: '',
        excNextDaySort: '',
        currentPage: 1,
        pageSize: 20
      },
      pageNumTotal: 0,//分页总页数
      total: 0,//总数
      activeId: null,//选中的id
      physioList: [],//理疗列表
      physioStatusList: physioStatusList,
      patientInfo: {},//患者信息
      reservationList: [],
      tableData: [],//表格数据
      column: [
        { type: "selection", selectable: (row) => { return row.propertyStatus == '0' ? true : false } },
        { label: "理疗项目", prop: "physioName", align: 'left', width: '232' },
        { label: "状态", slotName: "propertyStatus", align: 'left', width: '100' },
        { label: "总次数", prop: "totalNum", align: 'left', width: '100' },
        { label: "剩余次数", prop: "remainNum", align: 'left', width: '100' },
        { label: "上次执行日期", prop: "usePhysioDate", width: 200, align: 'left' },
        { label: "操作", slotName: "action", align: 'left' },
      ],
      multipleSelection: [],//选中的内容
      levelData: levelData,
      visibleObj: visibleObj,
      currentLevelData: {},//显示在最上面弹框对象信息
      dialogObj: {},//弹框所需参数
      recodeSearch: '',
      recodeList: [],//执行记录
      printDialogShow: false,//打印弹框
      printOrderId: '',//打印id
      propertyStatusList: propertyStatusList,
      isLoadMore: true,//是否加载下一页
      statusList: [
        { label: '进行中', value: '0' },
        { label: '已结束', value: '1' },
      ],
      reservationStatusMap: {
        '1': { text: '已预约', color: '#29C01B' },
        '2': { text: '已取消', color: '#667182' },
        '3': { text: '已执行', color: '#667182' },
        '4': { text: '已停诊', color: '#667182' },
        '5': { text: '已结束', color: '#667182' },
        '6': { text: '已签到', color: '#FE8F1F' }
      },
      activeStatus: '0',
      checked: '',
      pageIndex: 1,
      pageSize: 5,
      pageTotal: 0,
      centerLoading: false,
      user:{},
      careRecordMap: {
        pageNum: 1,
        pageSize: 10,
        list: []
      }
    }
  },
  computed: {
    computedDivision() {
      let that = this
      return function (a, b) {
        return that.$bigNumber(a, '/', isNull(b) ? 1 : b,0)
      }
    },
    computedIsHaveChecked() {
      return function (item) {
        let flag = false;
        item.orderCasePhysios && item.orderCasePhysios.forEach(v1 => {
          if (v1.checked) {
            flag = true
            return
          } else {
            v1.orderPhysioProperties && v1.orderPhysioProperties.forEach(v2 => {
              if (v2.checked) {
                flag = true
                return
              }
            })
          }
        })
        return flag;
      }
    },
    judgeIsExecute() {
      return function (phy) {
        let { executionMode, onlyNum, executeNum, totalNum,refundNum } = phy
        let execute =0
        let total = 0 
        let refund = 0
        // 1.执行=开单
        // 2.执行 + 退款 = 开单
        if (executionMode == 20) {
          execute = this.$bigNumber(executeNum,'/',onlyNum,2)
          total = this.$bigNumber(totalNum,'/',onlyNum,2) 
          refund = this.$bigNumber(refundNum,'/',onlyNum,2) 
        } else {
          execute = executeNum
          total = totalNum 
          refund = refundNum 
        }
        return execute == total || (execute + refund == total)
      }
    },
    judgeTotalNum(){
      return function(phy){
        let { executionMode,onlyNum, totalNum,refundNum} = phy
        let total = 0 
        let refund = 0
        if(executionMode == 20){
          total =  this.$bigNumber(totalNum,'/',onlyNum,2) 
          refund = this.$bigNumber(refundNum,'/',onlyNum,2) 
        }else{
          total = totalNum 
          refund = refundNum 
        }
        return this.$bigNumber(total,'-',refund)
      }
    }
  },
  filters: {
    //处理状态
    filterStatus(val) { return isNull(val) ? '' : dictText(val, physioStatusList) },
    //处理项目状态
    formatterPropertyStatus(val) { return isNull(val) ? '' : dictText(val, propertyStatusList) },
    // 处理时间
    filterTime(val) { return Utils.timeFormat(val, 'MM-DD') }
  },
  // 页面初始化
  async created() {
    this.user = this.$session.get('user')
    this.userType = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).type
    if (['0', '1'].includes(this.userType)) {
      this.searchFrom.searchType = '1'
      if (this.userType === '0') {
        this.searchFrom.doctorId = this.user.doctorId
      } else {
        await this.getHelperDoctorList()
      }
    } else {
      this.searchFrom.searchType = '0'
      await this.getDeptDoctorList()
    }
    this.systemTime = CommonDTO.getSystemTimeDTO()
    this.getPropertyPage().then(async res => {
      await this.getPatientReservation()
      this.getAccountPhysioProperty(this.patientInfo.patientId)
      this.getPhysioRecord(this.patientInfo.patientId)
      this.getCareRecordList(1)
    })
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 切换tab
     */
    async changeTab(val) {
      this.searchFrom.searchType = val
      this.searchFrom.currentPage = 1
      this.physioList = []

      this.activeRecordTab = 1

      await this.getPropertyPage()
      await this.getPhysioRecord(this.patientInfo.patientId)
      await this.getCareRecordList(1)
    },
    async getDeptDoctorList () {
      const res = await req.get('/patient/doctor/list', {
        deptId: this.$session.get('deptId'),
        status: '0'
      })
      if (res.code == 200) {
        this.deptDoctorList = res.rows
      }
    },
    async getHelperDoctorList () {
      const res = await req.get('/patient/doctor/doctorInfoByHelperId', {
        deptId: this.$session.get('deptId'),
        helperId: this.user.userId
      })
      if (res.code == 200) {
        this.helperDoctorList = res.data || []
        if (this.helperDoctorList.length > 0) {
          this.searchFrom.doctorId = this.helperDoctorList[0].doctorId
        }
      }
    },
    /**
     * 关闭弹框
     */
    dialogVisible(name, bol) {
      let visibleObj = this.visibleObj;
      name = name || this.currentLevelData.name;
      visibleObj[name] = bol != undefined ? bol : !visibleObj[name];
      this.$set(this, "visibleObj", visibleObj);
      this.setDialogLevel(name)
      this.getLevelData(name);
    },
    /**
     * 弹框确认
     */
    confirmUpdateData(data) {
      let currentLevelData = this.currentLevelData;
      currentLevelData.confirmfn && this[currentLevelData.confirmfn](data);
    },
    // 设置弹窗层级
    setDialogLevel(currentLevel) {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let that = this;
      if (this.visibleObj[currentLevel]) {
        levelData.map(v => {
          // 设置当前层的level为1，其余visible为true的level依次递增
          // enter confirm操作的始终是level为1的dialog
          if (v.name == currentLevel) {
            v.level = 1
          } else if (that.visibleObj[v.name]) {
            v.level = Utils.bigNumber(v.level, '+', 1)
          }
        })
      } else {
        levelData.map(v => {
          // 当前dialog关闭，则设置level为0， 其余visible为true的level依次减一
          if (v.name == currentLevel) {
            v.level = 0
          } else if (that.visibleObj[v.name] && Utils.gt(v.level, 0)) {
            v.level = Utils.bigNumber(v.level, '-', 1)
          }
        })
      }

      this.$set(this, 'levelData', levelData)
    },
    // 获取当前层级 及其Data
    getLevelData(name) {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let obj = {};
      let currentLevelData = levelData.filter(v => {
        return v.level == 1
      });
      obj = {
        ...currentLevelData[0],
      }
      this.$set(this, 'visibleObj', visibleObj)
      this.$set(this, 'currentLevelData', obj)
    },
    /**
    * 滚动条分页
    */
    getMoreList() {
      let that = this
      if (this.isLoadMore) {
        that.searchFrom.currentPage += 1
        that.getPropertyPage()
      }
    },
    /**
     * 获取账户理疗信息列表
     */
    getPropertyPage() {
      return new Promise(async (resolve, reject) => {
        let code = null
        let data = null
        if (['0', '1','3'].includes(this.searchFrom.searchType)) {
          const params = {
            searchType: this.searchFrom.searchType,
            deptId: (this.searchFrom.isCurrentDept === '1' || this.searchFrom.searchType === '0') ? this.$session.get('deptId') : null,
            physioStatus: this.searchFrom.physioStatus || null,
            startDate: (this.searchFrom.dateRange && this.searchFrom.dateRange.length > 0) && `${this.searchFrom.dateRange[0]} 00:00:00` || null,
            endDate: (this.searchFrom.dateRange && this.searchFrom.dateRange.length > 0) && `${this.searchFrom.dateRange[1]} 23:59:59` || null,
            doctorId: this.searchFrom.doctorId || null,
            excNextDaySort: this.searchFrom.excNextDaySort || null,
            currentPage: this.searchFrom.currentPage,
            pageSize: this.searchFrom.pageSize,
            searchValue: this.searchFrom.searchValue || null
          }
          const res = await req.post('/physio/accountPropertyPlatformPage', params)
          code = res.code
          data = res.data
        }
        if (['2'].includes(this.searchFrom.searchType)) {
          const params = {
            deptId: 'all',
            doctorId: this.searchFrom.doctorId || null,
            executeStartTime: new Date().Format('yyyy-MM-dd') + ' 00:00:00',
            executeEndTime:new Date().Format('yyyy-MM-dd') + ' 23:59:59',
            pageNum: this.searchFrom.currentPage,
            pageSize: this.searchFrom.pageSize,
            searchWhere: this.searchFrom.searchValue
          }
          const res = await getTodayReservations(params)
          code = res.code
          data = res.rows.map(v => {
            v['accountId'] = v.patientId
            v['patient'] = {
              patientId: v.patientId,
              patientName: v.patientName,
              phone: v.patientPhone,
              sex: v.sex,
              birthday: v.birthday,
              age: v.age
            }
            return v
          })
        }
        
        if (code == 200) {
          resolve()
          this.physioList = this.searchFrom.currentPage == 1 ? data : [...this.physioList, ...data];
          if (isNull(this.activeId)) {
            this.activeId = isEmptyArray(data) ? '' : data[0].accountId
            this.patientInfo = isEmptyArray(data) ? {} : data[0].patient
          }
          if (Utils.lt(data.length, this.searchFrom.pageSize)) {
            this.isLoadMore = false
          } else {
            this.isLoadMore = true
          }
        }
      })

    },
    /**
     * 搜索
     */
    handleSearch: debounce(function () {
      this.searchFrom.currentPage = 1
      this.getPropertyPage()
    }, 300),

    changeListDept () {
      this.searchFrom.currentPage = 1
      this.physioList = []
      this.getPropertyPage()
    },

    changeListDoctor () {
      this.searchFrom.currentPage = 1
      this.physioList = []
      this.getPropertyPage()
    },

    changeListStatus () {
      this.searchFrom.currentPage = 1
      this.physioList = []
      this.getPropertyPage()
    },

    changeListDate () {
      this.searchFrom.currentPage = 1
      this.physioList = []
      this.getPropertyPage()
    },

    changeListTimeSort () {
      switch (this.searchFrom.excNextDaySort) {
        case 1:
          this.searchFrom.excNextDaySort = 2
          break
        case 2:
          this.searchFrom.excNextDaySort = 1
          break
        default:
          this.searchFrom.excNextDaySort = 1
          break
      }
      this.searchFrom.currentPage = 1
      this.physioList = []
      this.getPropertyPage()
    },

    async getPatientReservation () {
      const res = await getReservationDetailByPatientId({ patientId: this.patientInfo.patientId })
      if (res.code === 200) {
        this.reservationList = res.data || []
      }
    },
    /**
     * 查询患者理疗资产信息
     */
    async getAccountPhysioProperty(id) {
      if (isNull(id)) return
      this.tableData = []
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        condition: {
          patientId: id,
          status: this.activeStatus
        }
      }
      this.centerLoading = true
      let { code, data } = await drugDTO.getAccountPhysioProperty(params)
      if (code == 200) {
        const todayDate = new Date().Format('yyyy-MM-dd')
        data.data && data.data.forEach(v1 => {
          const reservationInfo = this.reservationList.find(reservation => {
            const orderNumbers = reservation.orders && reservation.orders.map(order => { return order.orderNumber }) || []
            return orderNumbers.includes(v1.orderNumber) && reservation.doctorId === this.user.doctorId && JSON.parse(sessionStorage.getItem('user')).doctorId && new Date(reservation.reservationStartTime).Format('yyyy-MM-dd') == todayDate
          })
          const reservationDate = reservationInfo && new Date(reservationInfo.reservationStartTime).Format('yyyy-MM-dd') || ''
          
          v1['reservationInfo'] = reservationInfo || null
          v1['isTodayReservation'] = reservationDate === todayDate

          v1.checked = false

          let physioRemarkList = []

          v1.orderCasePhysios && v1.orderCasePhysios.forEach((v2, index2) => {
            v2.checked = false
            v2.orderPhysioProperties && v2.orderPhysioProperties.forEach(v3 => {
              v3.checked = false;
              if (!['', null, undefined].includes(v3.remark)) {
                physioRemarkList.push({
                  label: `理疗处方${index2 + 1}-${v3.physioName}`,
                  value: v3.remark
                })
              }
            })
          })

          v1['physioRemarkList'] = physioRemarkList
        })
        this.tableData = data.data
        this.pageTotal = data.totalElements || 0
      }
      this.centerLoading = false
    },
    /**
     * 查询执行记录
     */
    async getPhysioRecord(id) {
      let { code, data } = await drugDTO.physioRecord({ patientId: id, deptId: 'all', searchKey: this.recodeSearch })
      if (code == 200) {
        this.recodeList = data
        this.activeName = isEmptyArray(data) ? '' : data[0].accountPhysioExecuteRecordId
      }
    },
    /**
     * 切换患者
     */
    async choosePatient(patientId, accountId, patient) {
      this.activeId = accountId
      this.patientInfo = patient
      this.pageIndex = 1

      this.activeRecordTab = 1

      await this.getPatientReservation()
      this.getAccountPhysioProperty(patientId)
      this.getPhysioRecord(patientId)
      this.getCareRecordList(1)
    },
    /**
     * 多选触发
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 执行
     */
    async handleExecute(item, phy) {
      if (!isNull(phy)) {
        phy.checked = true
      }

      let { diagnosis, diagnosisList, orderCasePhysios, reservationInfo } = item
      let executeList = []
      orderCasePhysios && orderCasePhysios.forEach(v1 => {
        if (v1.checked) {
          executeList = [...executeList,...v1.orderPhysioProperties]
        } else {
          v1.orderPhysioProperties && v1.orderPhysioProperties.forEach(v2 => {
            if (v2.checked) {
              executeList.push(v2)
            }
          })
        }
      })

      try {
        const nowDoctorId = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).doctorId || ''
        const nowUserId = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).userId || ''
        const nowDeptId = sessionStorage.getItem('deptId') || ''

        const hasYbPay = item.ybPay === 1
        if (hasYbPay) {
          const res = await req.get('/patient/doctor/qualifications', {
            userId: nowUserId
          })
          if (res.code === 200) {
            const qualifications = res.data && res.data.map(v => { return v.qualificationValue }) || []
            if (!qualifications.includes('1')) {
              this.$confirm('您不具备医保执行资质，无法执行该项目', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {}).catch(() => {})
              return false
            }
          }
        }
        
        let text = ''
        let isConfirm = false

        if (nowDoctorId != item.doctorId) {
          text = '当前项目是其他医生开单，是否确认执行?'
          isConfirm = true
        }
        if (nowDeptId != item.deptId) {
          text = '当前项目是其他医馆开单，是否确认执行?'
          isConfirm = true
        }
        if (nowDoctorId != item.doctorId && nowDeptId != item.deptId) {
          text = '当前项目是其他医馆/医生开单，是否确认执行?'
          isConfirm = true
        }

        if (isConfirm) {
          await this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
      } catch (error) {
        return false
      }
      
      this.dialogObj.executeList = executeList
      this.dialogObj.diagnosis = diagnosis
      this.dialogObj.diagnosisList = diagnosisList
      this.dialogObj.deptId = item.deptId
      this.dialogObj.reservationInfo = reservationInfo
      this.dialogObj.patientId = this.patientInfo.patientId
      this.dialogVisible('executeDialog', true)
    },

    quickReservation (item) {
      let flag = this.computedIsHaveChecked(item)
      if (!flag) {
        this.$message.error('请勾选执行项目')
        return
      }
      let productList = []
      item.orderCasePhysios.forEach(v1 => {
        v1.orderPhysioProperties.forEach(v2 => {
          if (v2.checked) {
            productList.push({
              physioId: v2.physioId,
              physioName: v2.physioName
            })
          }
        })
      })
      this.$refs['quickReservationDialog'].open({
        orderId: item.orderId,
        orderNumber: item.orderNumber,
        patientId: this.patientInfo.patientId,
        productList: productList
      })
    },

    /**
     * 多选执行
     */
    multipleExecute(item) {
      let flag = this.computedIsHaveChecked(item)
      if (!flag) {
        this.$message.error('请勾选执行项目')
        return
      }
      this.handleExecute(item)
    },
    /**
     * 执行并打印
     */
    executeAndPrint(executeList) {
      let obj = {
        patientInfo: this.patientInfo,
        executeList: executeList
      }
      this.searchFrom.currentPage = 1
      this.getPropertyPage().then(res => {
        this.getAccountPhysioProperty(this.patientInfo.patientId)
        this.getPhysioRecord(this.patientInfo.patientId)
      })
      this.printOrderId = isEmptyArray(executeList) ? '' : executeList[0].batchNo
      this.dialogObj.executePrintObj = obj
      this.dialogVisible('executeDialog', false)
      this.dialogVisible('executePrintDialog', true)
    },
    /**
     * 查看详情
     */
    async handleDetail(row) {
      this.dialogObj.ctOrderId = row.ctOrderId
      this.dialogObj.physioId = row.physioId
      this.dialogVisible('executeDetail', true)
    },
    /**
     * 执行确定弹框
     */
    executeDialogConfirmfn() {
      this.searchFrom.currentPage = 1
      this.getPropertyPage().then(res => {
        this.getAccountPhysioProperty(this.patientInfo.patientId)
        this.getPhysioRecord(this.patientInfo.patientId)
      })
      this.dialogVisible('executeDialog', false)
    },
    /**
     * 打开执行看板
     */
    openBoard() {
      this.dialogVisible('executeBoardDialog', true)
    },
    openReservationBoard () {
      this.$refs['reservationBoard'].open()
    },
    openTrilateralReservation () {
      this.$refs['trilateralReservationDialog'].open()
    },
    /**
     * 打印 
     * 2024 12 26 产品要求不展示打印预览
     */
    // print(item) {
    //   let obj = {
    //     patientInfo: this.patientInfo,
    //     executeList: item.items
    //   }
    //   this.printOrderId = item.batchNo
    //   this.dialogObj.executePrintObj = obj
    //   this.dialogVisible('executePrintDialog', true)
    // },
    print(item) {
      this.printOrderId = item.batchNo
      this.executePrintDialogConfirmfn()
    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
     */
    printSuccess() {
      this.dialogVisible('executePrintDialog', false)
    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    /**
     * 打印弹框确认
     */
    executePrintDialogConfirmfn() {
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    //判断是否禁用
    isDisabledFun(item) {
      let currentMonth = this.$moment().month() + 1;
      let month = this.$moment(item.executeStartTime).month() + 1
      return currentMonth !== month || item.userName !== this.$session.get('user').nickName || item.isRevoke;
    },
    //撤销执行
    revokeExecute(item) {
      msgboxWarning(this, {
        type: '',
        title: '撤销确认',
        message: "是否确认撤销执行该条执行记录？",
        confirmFn: debounce(async () => {
          let accountPhysioExecuteRecordIds = []
          item.items && item.items.forEach(obj => {
            accountPhysioExecuteRecordIds.push(obj.accountPhysioExecuteRecordId)
          })
          let { code } = await drugDTO.revokePhysio({ accountPhysioExecuteRecordIds })
          if (code === 200) {
            this.$message.success('撤销成功！')
            this.getPropertyPage().then(res => {
              this.getAccountPhysioProperty(this.patientInfo.patientId)
              this.getPhysioRecord(this.patientInfo.patientId)
            })
          }
        }, 1000, true),
        cancelFn: () => {
        },
      });
    },
    //判断是否全选
    judgeAllChecked() {
      this.tableData.forEach(v1 => {
        v1.orderCasePhysios && v1.orderCasePhysios.forEach(v2 => {
          v2.checked = v2.orderPhysioProperties && v2.orderPhysioProperties.every(v3 => v3.checked)
        })
      })
    },
    //全选
    allSelect(obj) {
      obj.orderPhysioProperties.forEach(v => { 
        if(!this.judgeIsExecute(v)){
          v.checked = obj.checked 
        }
      })
      this.judgeAllChecked()
    },
    changeStatus(status) {
      this.pageIndex = 1
      this.activeStatus = status
      this.getAccountPhysioProperty(this.patientInfo.patientId)
    },
    currentPageFun(pageIndex) {
      this.pageIndex = pageIndex
      this.getAccountPhysioProperty(this.patientInfo.patientId)
    },
    cancelExecute(list){
      this.tableData.forEach(v1=>{
        v1.orderCasePhysios.forEach(v2=>{
          v2.orderPhysioProperties.forEach(v3=>{
            list.forEach(v4=>{
              if(v4.physioId == v3.physioId && v4.ctOrderId == v3.ctOrderId){
                v3.checked = false
              }
            })
          })
        })
      })
      this.judgeAllChecked()
      this.$forceUpdate()
      this.dialogVisible('executeDialog', false)
    },
    // 理疗执行记录搜索
    recodeSearchInput: debounce(function () {
      this.getPhysioRecord(this.patientInfo.patientId)
    }, 300),
    async toggleRecordTab (tab) {
      this.activeRecordTab = tab
      if (tab == 1) {
        await this.getPhysioRecord(this.patientInfo.patientId)
      } else {
        this.careRecordMap.pageNum = 1
        this.careRecordMap.list = []
        this.getCareRecordList()
      }
    },
    addCareRecord () {
      this.$refs['careRecordEdit'].open(this.patientInfo.patientId)
    },
    async getCareRecordList (type = null) {
      if (type == 1) {
        this.careRecordMap.pageNum = 1
        this.careRecordMap.list = []
      }
      const res = await req.get('/physio/careRecord/history', {
        patientId: this.patientInfo.patientId,
        pageNum: this.careRecordMap.pageNum,
        pageSize: this.careRecordMap.pageSize
      })
      if (res.code === 200) {
        this.careRecordMap.list = this.careRecordMap.list.concat(res.rows)
        this.careRecordMap.total = res.total || 0
      }
    },
    getMoreCareRecordList () {
      if (this.careRecordMap.list.length >= this.careRecordMap.total) {
        return
      }
      this.careRecordMap.pageNum = this.careRecordMap.pageNum + 1
      this.getCareRecordList()
    },
    submitCareRecordSuccess () {
      this.careRecordMap.pageNum = 1
      this.careRecordMap.list = []
      this.getCareRecordList()
    },
    openCallNum () {
      this.$nextTick(() => {
        let doctorId = ''
        let doctorName = ''
        if (['0'].includes(this.userType)) {
          doctorId = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).doctorId || ''
          doctorName = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).nickName || ''
        } else if (['1'].includes(this.userType)) {
          const doctor = this.helperDoctorList.find(v => { return v.doctorId == this.searchFrom.doctorId })
          doctorId = doctor.doctorId
          doctorName = doctor.doctorName
        }
        this.$refs.callNumPanel.init({ doctorId: doctorId, doctorName: doctorName })
      })
    },
    closeCallNum () {
      this.$refs.callNumPopover.doClose()
    }
  },
}
</script>
<style lang="less" scoped src="./index.less"></style>
<style lang="less">
  .physioExecute_advice_popover {
    background-color: #FFFBE8;
  }

  .physioExecute_advice_popover .popper__arrow::after {
    border-bottom-color: #FFFBE8 !important;
  }
</style>